////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const errorManager = {
	createError: (error, redirectPath = '') => ({
		type: ActionsTypes.CREATE_ERROR,
		payload: {
			error,
			redirectPath,
		},
	}),
	criticalError: (error) => ({
		type: ActionsTypes.CREATE_CRITICAL_ERROR,
		payload: {
			error,
		},
	}),
	modeMaintenance: (redirectPath) => ({
		type: ActionsTypes.CREATE_MAINTENANCE_MODE,
		payload: {
			redirectPath,
		},
	}),
}

export default errorManager
